module.exports = __webpack_public_path__ + "img/money-roup.e4d25ce1.png";